
import { t } from 'i18next';
import React from 'react';
import NearMouseTooltip from './helpers/NearMouseTooltip';

const AIDetailsButton = ({ icon, label, onClick, isOpen, patientName, patientSex, patientAge, aiModel, aiFindings }) => {
  const Icon = icon;
  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: '100%', width: '196px', cursor: 'pointer', alignItems: 'center', padding: '0px 12px 0px 11px' ,
      /*margin: '6px 0px 6px 10px',*/ borderRadius: '0px 0px 0px 10px',
      backgroundColor: isOpen ? '#0C1A2C' :'',
      //border: isOpen ? '0px solid rgba(0, 123, 218, 1)' :'0.3px solid rgba(245, 245, 245, 0.20)',
      borderRight: isOpen ? '3px solid #007BDA' : '3px solid #828488',
    }} onClick={onClick}>
      <NearMouseTooltip content={t(`AI Output: ${label}`)}>

        <div style={{ width: '22px', height: '22px' }}>{icon && <Icon isOpen={isOpen} />}</div>
      </NearMouseTooltip>

      <div
        style={{
          padding: '0px 0px 0px 8px',
          width: '144px',
          height: '100%',
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
          color: '#C4C4C4',
          fontSize: 10,
          fontFamily: 'Open Sans',
          fontWeight: '400',
        }}
      >
        {/* <div
  style={{
    height: '15px',
    borderBottom: '2px groove rgba(255, 255, 255, 0.15)',
      // isOpen
      // ? '2px groove rgba(0, 123, 218, 1)'
      // : '2px groove rgba(255, 255, 255, 0.15)',
    overflow: 'hidden', // ensure container clips child text
  }}
>
  <NearMouseTooltip content={t(`${patientName} ${patientSex} | ${patientAge}`)}>
    <div
      style={{
        lineHeight: '15px',
        fontSize: 10,
        fontFamily: 'Open Sans',
        fontWeight: 400,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '123px', // only works if parent has constrained width
        display: 'block',
      }}
    >
      {patientName}&nbsp;&nbsp;{patientSex}&nbsp;|&nbsp;{patientAge}
    </div>
  </NearMouseTooltip>
</div> */}


        <NearMouseTooltip content={`${aiFindings}`}>
          <div
            style={{
              lineHeight: '15px',
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'column',
              color: '#C4C4C4',
              fontSize: 10,
              fontFamily: 'Open Sans',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '144px'
              
             
            }}
          // title={aiFindings}
          >
            {aiFindings}
          </div>
        </NearMouseTooltip>
        <NearMouseTooltip content={t(`AI: ${aiModel}`)}>
          <div
            style={{
              lineHeight: '15px',
              justifyContent: 'center',
              display: 'block',
              flexDirection: 'column',
              color: '#C4C4C4',
              fontSize: 10,
              fontFamily: 'Open Sans',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '144px',
            }}
          >

            AI: {aiModel}
          </div>
        </NearMouseTooltip>
      </div>
                                {/* <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                      <svg width="2" height="49" viewBox="0 0 2 49" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="1" y1="-4.37114e-08" x2="1" y2="49" stroke={isOpen ? "#007BDA" : "white"} stroke-opacity="0.5" stroke-width="2"/>
</svg>

                    </div> */}

    </div>


  );
};

export default AIDetailsButton;